import React, { useContext, Fragment, useState } from "react";
import { Link, useHistory } from "react-router-dom";

import AuthContext from "../../context/auth/authContext";
import PostContext from "../../context/post/postContext";

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import EditIcon from '@mui/icons-material/Edit';
import PeopleIcon from '@mui/icons-material/People';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuIcon from '@mui/icons-material/Menu';
import { makeStyles } from "@material-ui/core/styles";

const Navbar = ({ onMenuToggle }) => {
  const authContext = useContext(AuthContext);
  const postContext = useContext(PostContext);

  const { isAuthenticated, logout, user } = authContext;
  const { clearPosts } = postContext;

  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);

  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    title: {
      flexGrow: 1,
    },
    appTab: {
      [theme.breakpoints.down("xs")]: { display: "none" },
    },
  }));

  const classes = useStyles();

  const history = useHistory();

  const onLogout = () => {
    setAnchorEl(null);
    logout();
    clearPosts();
    history.push("/login");
  };

  const handleAvatarClick = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleEditProfile = () => {
    setAnchorEl(null);
    history.push("/profile");
  };

  const avatarSrc = user && user.avatar && user.avatar.image_link ? user.avatar.image_link : null;

  // Avatar + dropdown menu — shown on all screen sizes
  const avatarMenu = (
    <Fragment>
      <IconButton onClick={handleAvatarClick} sx={{ ml: 1 }}>
        <Avatar
          src={avatarSrc}
          sx={{ width: 32, height: 32, bgcolor: 'rgba(255,255,255,0.3)' }}
        >
          {!avatarSrc && user && user.first_name ? user.first_name.charAt(0).toUpperCase() : null}
        </Avatar>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: { mt: 1, minWidth: 160, borderRadius: 2 },
        }}
      >
        <MenuItem onClick={() => { setAnchorEl(null); history.push("/following/manage"); }}>
          <ListItemIcon>
            <PeopleIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Your Connections</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleEditProfile}>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Edit Profile</ListItemText>
        </MenuItem>
        <MenuItem onClick={onLogout}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Log Out</ListItemText>
        </MenuItem>
      </Menu>
    </Fragment>
  );

  return (
    <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 10 }} style={{ background: "#3498db" }}>
      <Toolbar>
        <IconButton
          color="inherit"
          edge="start"
          onClick={onMenuToggle}
          sx={{ mr: 2, display: { md: 'none' } }}
        >
          <MenuIcon />
        </IconButton>
        <Typography
          variant="h6"
          className={classes.title}
          component={Link}
          to="/destinations"
          sx={{ color: 'inherit', textDecoration: 'none' }}
        >
          TripCard
        </Typography>
        {/* Manage: desktop only, admin only */}
        {isAuthenticated && (
          <Fragment>
            {user && user.role === 'admin' && (
              <Button component={Link} to="/manage" color="inherit" sx={{ textTransform: 'none', display: { xs: 'none', md: 'inline-flex' } }}>
                Manage
              </Button>
            )}
          </Fragment>
        )}
        {/* Avatar or Login: always visible */}
        {isAuthenticated ? avatarMenu : (
          <Fragment>
            <Button component={Link} to="/login" color="inherit" sx={{ textTransform: 'none' }}>
              Login
            </Button>
            <Button component={Link} to="/register" color="inherit" sx={{ textTransform: 'none' }}>
              Register
            </Button>
          </Fragment>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
